import APP_CONST from '@/constants/AppConst';
import { inviteAuthorizedPickup, inviteEmergencyContact } from '@/services/userService/users-api';
import APP_UTILITIES from '@/utilities/commonFunctions';
import UIkit from 'uikit';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import commonEntry from '@/store/modules/commonEntry';

export enum ContactType {
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  AUTHORIZED_PICKUP = 'AUTHORIZED_PICKUP',
}

@Component({})
export default class InviteLink extends Vue {
  shouldDisplay: Boolean = true;
  featureEnabled: Boolean = true;

  @Prop({
    validator: function (value) {
      // Value must be a contact type
      return Object.keys(ContactType).includes(value);
    },
  })
    contactType!: string;

  @Prop()
    scholarGuid!: string;

  @Prop()
    phoneNumber!: string;

  @Prop()
    contactGuid!: string;

  get accountData() {
    return commonEntry.accountDetail;
  }

  @Watch('accountData', { deep: true, immediate: true })
  accountDataWatch(value: any) {
    const getAccountDataValue = value.data;
    if (getAccountDataValue === undefined) {
      //If there is no data in accountDetail we need to fetch, this should not happen in the normal flow.
      const design: any = JSON.parse(APP_UTILITIES.getCookie('accountDesign') || '');
      const accountId = design.accountId;
      commonEntry.accountById(accountId);
    }
    else if (!getAccountDataValue.appSetting.pickup) {
      this.featureEnabled = false;
      this.shouldDisplay = false;
    }
  }

  created() {
    this.shouldDisplay = !!this.phoneNumber && this.featureEnabled;
  }

  handleClick() {
    if (this.contactType === ContactType.EMERGENCY_CONTACT) {
      this.inviteEmContact(this.contactGuid);
    }
    else {
      this.invitePickupContact(this.contactGuid, this.scholarGuid);
    }
  }

  invitePickupContact(emContactGuid: string, scholarGuid: string) {
    inviteAuthorizedPickup(emContactGuid, scholarGuid).then((response: any) => {
      if (response.status == APP_CONST.RESPONSE_200) {
        UIkit.notification.closeAll();
        UIkit.notification({
          message: 'Invite Sent Successfully',
          status: 'success',
          pos: 'top-center',
          timeout: 5000,
        });
      }
      else {
        UIkit.notification.closeAll();
        UIkit.notification({
          message: 'User has already been invited',
          status: 'warning',
          pos: 'top-center',
          timeout: 5000,
        });
      }
    });
  }

  inviteEmContact(emContactGuid: string) {
    inviteEmergencyContact(emContactGuid).then((response: any) => {
      if (response.status == APP_CONST.RESPONSE_200) {
        UIkit.notification.closeAll();
        UIkit.notification({
          message: 'Invite Sent Successfully',
          status: 'success',
          pos: 'top-center',
          timeout: 5000,
        });
      }
      else {
        UIkit.notification.closeAll();
        UIkit.notification({
          message: 'User has already been invited',
          status: 'warning',
          pos: 'top-center',
          timeout: 5000,
        });
      }
    });
  }
}
